import { Component, Input, OnInit } from '@angular/core';

import { MemoPaymentView } from '@app/shared/views/MemoPaymentView';

import { fadeIn } from 'assets/animations/animations';
import { default as constantsFile } from '@app/shared/constants.json';

@Component({
  selector: 'app-payment-period-range-form',
  templateUrl: './payment-periodrange-form.component.html',
  styleUrls: ['./payment-periodrange-form.component.scss'],
  animations: [ fadeIn ],
  standalone: false
})
export class PaymentPeriodrangeFormComponent implements OnInit {

  // Variable de control
  alive: boolean;

  constants: any = constantsFile.constants;

  // Valores de constantes
  patternPeriod = this.constants.pattern.period;

  @Input() payment: MemoPaymentView;
  @Input() memoContentOriginSelected: string;
  @Input() isNewPayment: boolean;
  @Input() isTaskEditable: boolean;
  @Input() isTaskDetail: boolean;
  @Input() paymentSavedOk: boolean;

  constructor(
  ) {  }

  ngOnInit(): void { }
}
